export const URL_TEXT_OPTIONS = [
  'Pre-Save',
  'Buy',
  'Explore',
]
